import { Injectable } from '@angular/core';
import { WebSocketsService } from './web-sockets.service';
import { NotificationType } from '@interfaces/web-sockets/wsreceived-message';
import { UserAction } from '../enums/user-action';
import { UserEvent } from '../enums/user-event';
import { InstitutionService } from './institution.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor(
    private wsService: WebSocketsService,
  ) { }

  private sendSessionLog(notifyData: any): void {
    const notifyEvent = {
      timestamp: new Date(),
      socketKey: this.wsService.socketKey,
      notifyType: 21, // SessionLog
      notifyData: JSON.stringify(notifyData)
    };
    if (this.wsService.isSocketOpen()) {
      this.wsService.socket?.send(JSON.stringify(notifyEvent));
    }
  }

  logPage(pageName: string): void {
    this.sendSessionLog({ page: pageName });
  }

  logAction(action: UserAction, details?: any): void {
    this.sendSessionLog({ action, ...(details || {}) });
  }

  logEvent(event: UserEvent, details?: any): void {
    this.sendSessionLog({ event, ...(details || {}) });
  }
}
